export default "__VITE_ASSET__CgCid_F2__"